import {
  MenuItem,
  MenuList,
  MenuPopover,
  Menu,
  MenuTrigger,
} from '@fluentui/react-components';
import {
  ArrowUploadFilled,
  ArrowUploadRegular,
  AttachRegular,
  bundleIcon,
} from '@fluentui/react-icons';
import { StyledButton } from './AttachFilePopover.styled';

interface AttachPopoverProps {
  handleUpload: () => void;
}

export const AttachPopover = ({ handleUpload }: AttachPopoverProps) => {
  const ArrowUploadIcon = bundleIcon(ArrowUploadFilled, ArrowUploadRegular);

  return (
    <Menu>
      <MenuTrigger>
        <StyledButton size="medium" icon={<AttachRegular />}>
          {' '}
          Attach a file
        </StyledButton>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem icon={<ArrowUploadIcon />} onClick={handleUpload}>
            Upload from this device
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
